<template>
  <main id="content" class="grow p-[50px] scale-100">
    <router-view />
  </main>
</template>

<script>
import { RouterView } from "vue-router";

import ensureValidVolumeAndSchoolLevel from "../../router/routes/digibord/ensure-valid-volume-and-school-level";

// Note `.scale-100`:
// bugfix for mobile safari where menu-subitems (expand) is cut
// halfway by the perspective image when it's directly behind it.
// Adds 'stacking context'.

export default {
  name: "DigibordContent",
  components: {
    RouterView,
  },
  async beforeRouteEnter(to, from, next) {
    await ensureValidVolumeAndSchoolLevel(to, next);
  },
  async beforeRouteUpdate(to, from, next) {
    await ensureValidVolumeAndSchoolLevel(to, next);
  },
};
</script>
